<template>
  <div>
    <a-breadcrumb style="margin: 16px 0">
      <a-breadcrumb-item
        ><router-link to="/teacher/workGroup"
          >作业批改</router-link
        ></a-breadcrumb-item
      >
      <a-breadcrumb-item>作业推荐</a-breadcrumb-item>
    </a-breadcrumb>
    <div>
      <a-row>
        <!-- <a-col :span="5">
          <a-input placeholder="作品名" v-model="queryParam.workName"></a-input>
        </a-col> -->
        <a-col :span="5">
          <a-input style="width: 150px" placeholder="学生名" v-model="queryParam.realname"></a-input>
        </a-col>
        <!-- <a-col :span="5">
          <j-dict-select-tag
            style="width: 120px"
            placeholder="代码类型"
            v-model="queryParam.codeType"
            dictCode="code_type"
          />
        </a-col> -->
        <a-col :span="4">
          <a-button type="primary" @click="search">查询</a-button>
        </a-col>
      </a-row>
      <a-divider></a-divider>
    </div>
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="showDepart" slot-scope="t, r">
          <!-- <a-button>{{r.recommendDepartIds?"部分班级":"全部班级"}}</a-button> -->
          <j-select-depart 
          placeholder="全部班级" 
          :multi="true" 
          :onlyMyDepart="true"
          :onlyLeaf="true"
           :onlyCategory="3" 
           :rootOpened="true" 
           v-model="r.recommendDepartIds"
           @change="changeShowDepart($event, r)"/>
        </span>
        <span slot="showTime" slot-scope="t, r">
           <a-select @change="changeShowTime($event, r)" value="">
             <a-select-option key="" value="">选择时长</a-select-option>
             <a-select-option key="3" value="3">3天</a-select-option>
             <a-select-option key="5" value="5">5天</a-select-option>
             <a-select-option key="7" value="7">7天</a-select-option>
           </a-select>
        </span>

        <span slot="action" slot-scope="text, record">
          <a-button style="display:inline-block;" @click="handleEdit(record)">查看详情</a-button>
          <a-button style="display:inline-block;" type="danger" @click="handleCancelRecommend(record)">取消展示</a-button>
        </span>
      </a-table>
    </div>
    <WorkReviewModal ref="modalForm" @finished="search" />
  </div>
</template>

<script>
import moment from "moment";
import WorkReviewModal from "./modules/WorkReviewModal";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSelectDepart from '@/components/jeecg/JSelectDepart'
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { putAction } from "@/api/manage";


export default {
  name: "TeacherWork",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    WorkReviewModal,
    JSelectDepart
  },
  props: {
    isInner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "学生",
          align: "center",
          dataIndex: "realname",
          width: 120,
        },
        {
          title: "班级",
          align: "center",
          width: 100,
          dataIndex: "departId_dictText",
        },
        {
          title: "作品名",
          align: "center",
          width: 250,
          dataIndex: "workName",
        },
        {
          title: "代码类型",
          align: "center",
          width: 100,
          dataIndex: "codeType_dictText",
        },
        {
          title: "设置显示班级",
          dataIndex: "showDepart",
          align: "center",
          scopedSlots: { customRender: "showDepart" },
        },
        {
          title: "延长显示时间",
          dataIndex: "endTime",
          align: "center",
          scopedSlots: { customRender: "showTime" },
        },
        {
          title: "展示结束时间",
          align: "center",
          width: 100,
          dataIndex: "recommendEndTime",
          customRender(v){
            if(v){
              let timeDiff = moment(v).diff(moment(), "hours")
              return Math.floor(timeDiff/24) + "天" + timeDiff%24 + "小时"
            }else{
              return '永久'
            }
          }
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
           width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingWork/choiceness?time=now",
        edit: "/teaching/teachingWork/edit",
      },
      disableMixinCreated: true, //禁用mixin的created方法
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1)
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
    },
    handleRecommendAgain(r){
      putAction(this.url.edit, {
        id: r.id,
        recommendEndTime: moment(new Date()).subtract(-7, "days").format('YYYY-MM-DD HH:mm:ss')
      }).then(res=>{
        this.search();
      })
    },
    handleCancelRecommend(r){
      putAction(this.url.edit, {
        id: r.id,
        recommendEndTime: moment(new Date()).subtract(1, "days").format('YYYY-MM-DD HH:mm:ss')
      }).then(res=>{
        this.search();
      })
    },
    changeShowTime(v, r){
      if(v){
        putAction(this.url.edit, {
          id: r.id,
          recommendEndTime: moment(new Date()).subtract(-v, "days").format('YYYY-MM-DD HH:mm:ss')
        }).then(res=>{
          this.search();
        })
      }
    },
    changeShowDepart(v, r){
      putAction(this.url.edit, {
        id: r.id,
        recommendDepartIds: v
      }).then(res=>{
        this.search();
      })
    }
  },
};
</script>

<style lang="less" scoped>
</style>